import React from 'react';
import { icons } from './icons';

type Props = {
  icon: keyof typeof icons;
  className?: string;
  onClick?: (e: React.MouseEvent<SVGSVGElement, MouseEvent>) => void;
  onMouseDown?: (e: React.MouseEvent<SVGSVGElement, MouseEvent>) => void;
  style?: React.CSSProperties;
};

export const Icon: React.FC<Props> = ({
  icon,
  className = '',
  style = {},
  onClick,
  onMouseDown,
}) => {
  const IconSVG = icons[icon] || icons.lightBulb;

  return React.cloneElement(IconSVG as any, { className, onClick, style, onMouseDown });
};
